import { createSlice } from '@reduxjs/toolkit';
import { getPersonRecordHistoryLinkThunk } from './History.thunk';

export const personHistorySlice = createSlice({
  name: 'personHistory',
  initialState: {
    list: {
      items: [],
      loading: true,
      haveMore: [] as number[],
    },
  },
  reducers: {
    //
  },
  extraReducers: builder => {
    builder.addCase(
      getPersonRecordHistoryLinkThunk.pending,
      (state, action) => {
        state.list = { ...state.list, loading: true };
      },
    );
    builder.addCase(
      getPersonRecordHistoryLinkThunk.fulfilled,
      (state, action) => {
        const { data, pagination } = action.payload;
        const items: any = {};
        const target = data?.[0]?.target;
        if (pagination.current_page < pagination.last_page && !state.list.haveMore.includes(target)) {
          state.list.haveMore.push(target);
        } else {
          const deleteItemIndex = state.list.haveMore.indexOf(target);
          if (deleteItemIndex !== -1) {
            state.list.haveMore.splice(deleteItemIndex, 1);
          }
        }
        const currentItems = JSON.parse(JSON.stringify(state.list.items));
        for (const item of data) {
          const _locState = items[item.target] || [];
          items[item.target] = [..._locState, item];
        }

        if (Object.values(state.list.items).length) {
          for (const currentItemKey of Object.keys(currentItems)) {
            if (!items[currentItemKey]) {
              items[currentItemKey] = currentItems[currentItemKey];
            }
          }
        }
        state.list = { ...state.list, items, loading: false };
      },
    );
    builder.addCase(
      getPersonRecordHistoryLinkThunk.rejected,
      (state, action) => {
        // state.list = { ...state.list, loading: false };
      },
    );
  },
});

export const getPersonHistoryList = (state: any) => state.personHistory.list;

export default personHistorySlice.reducer;
